module.exports = __webpack_public_path__ + "static/CloudBattery-3-light-0fd4bed54e38453d58554bf9742b169c.svg";